function collectionDescriptionInit() {
  const collapsibleToggles = document.querySelectorAll('[data-collapsible]');
  
  collapsibleToggles.forEach(toggle => {
    const target = document.querySelector(toggle.getAttribute('data-collapsible'));
    toggle.addEventListener('click', () => {
      toggle.classList.toggle('is-open');
      target.classList.toggle('is-open');
    });
  })
}

document.addEventListener('DOMContentLoaded', () => {
  collectionDescriptionInit()
})